import React from 'react';
export var themes = {
    diag: {
        primaryColor: '#81439c',
        href: 'diag'
    },
    fepo: {
        primaryColor: '#049842',
        href: 'fepo'
    },
    fepo_pro: {
        primaryColor: '#26aa86',
        href: 'fepo'
    },
    test_constructor: {
        primaryColor: '#2d529c',
        href: 'training'
    },
    ias: {
        primaryColor: '#1b77d2',
        href: 'training'
    },
    olymp: {
        primaryColor: '#f67e04',
        href: 'olymp'
    },
    olymp_en: {
        primaryColor: '#f67e04',
        href: 'olymp-en'
    },
    olps: {
        primaryColor: '#f67e04',
        href: 'olymp'
    },
    fieb: {
        primaryColor: '#bd3054',
        href: 'bakalavr'
    },
    tfieb: {
        primaryColor: '#812136',
        href: 'tfieb'
    },
    default: {
        primaryColor: '#009846',
        href: ''
    }
};
var ThemeContext = React.createContext(themes.default);
export default ThemeContext;
//# sourceMappingURL=context.js.map